import { Icon } from "@trueskin-web/components"
import { checkIcon } from "@trueskin-web/theme/icons/checkIcon"

import smileSvg from "../images/smile.svg"

import Plan from "./plan"

const subscriptionServices = [
  "Jederzeit ärztliche Beratung",
  "Regelmäßige Analysen Deiner Haut und Anpassungen Deiner Formel",
  "Kostenlose Lieferung zu Dir nach Hause ",
]

const SubscriptionService = ({ children }) => (
  <li sx={{ display: "inline-flex", columnGap: 1 }}>
    <Icon icon={checkIcon} color="primary" />
    {children}
  </li>
)

const Subscriptions = ({ plans, selectedPlanId, onSelect }) => (
  <div
    sx={{
      background: "white",
      borderRadius: "4px",
      overflow: "hidden",
    }}
    data-component-name="PlanSelectionSubscriptionPlans"
  >
    <div
      sx={{
        py: 2,
        px: 4,
        fontSize: 1,
        fontWeight: "bold",
        borderRadius: "4px 4px 0 0",
        background: "notification",
      }}
    >
      Spare bis zu 40%
    </div>

    <div
      sx={{
        p: 4,
      }}
    >
      <div
        sx={{
          fontFamily: "display",
          fontSize: 4,
          lineHeight: 1.4,
        }}
      >
        Fortlaufende Behandlung für dauerhaft bessere Haut
      </div>

      <ul
        sx={{
          my: 4,
          pl: 0,
          listStyle: "none",
          fontSize: 1,
          "&>li:not(:first-child)": {
            mt: 2,
          },
        }}
      >
        {subscriptionServices.map((text, index) => (
          <SubscriptionService key={index}>{text}</SubscriptionService>
        ))}
      </ul>

      <div
        sx={{
          mb: 4,
          py: 2,
          px: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
          fontSize: 0,
          color: "#0B1770",
          borderRadius: "8px",
          background: "brandPrimaryUltraLight",
        }}
      >
        <Icon icon={smileSvg} size="sm" />
        91% unserer Patient:innen sehen Verbesserungen nach 6–8 Wochen.
      </div>

      <div
        sx={{
          display: "grid",
          gap: 4,
        }}
      >
        {plans.map((plan) => (
          <Plan
            key={plan.id}
            plan={plan}
            selectedPlanId={selectedPlanId}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  </div>
)

export default Subscriptions
